module.exports = __webpack_public_path__ + "21aba819b70fac1e502d63dd19ca8f1d.png";